// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_TAXES, TAXES, EDIT_TAXES, GET_TAXES, DELETE_TAXES } from '../../../../common/constant'

export const actionTaxes = createAsyncThunk('appTaxes/actionTaxes', async (params, thunkAPI) => {
    return await post(TAXES, params, thunkAPI)
})

export const actionAddTaxes = createAsyncThunk('appTaxes/actionAddTaxes', async (params, thunkAPI) => {
    return await put(ADD_TAXES, params, thunkAPI)
})

export const actionGetTaxes = createAsyncThunk('appTaxes/actionGetTaxes', async (params, thunkAPI) => {
    return await post(GET_TAXES, params, thunkAPI)
})

export const actionEditTaxes = createAsyncThunk('appTaxes/actionEditTaxes', async (params, thunkAPI) => {
    return await post(EDIT_TAXES, params, thunkAPI)
})

export const actionDeleteTaxes = createAsyncThunk('appTaxes/actionDeleteTaxes', async (params, thunkAPI) => {
    return await post(DELETE_TAXES, params, thunkAPI)
})

export const appTaxesSlice = createSlice({
    name: 'appTaxes',
    initialState: {
        //list
        loading: false,
        taxes: null,

        //add
        loadingAdd: false,
        addTaxes: null,

        //get
        loadingGet: false,
        getTaxes: null,

        //edit
        loadingEdit: false,
        editTaxes: null,

        //delete
        loadingDelete: false,
        deleteTaxes: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetTaxesResponse: (state) => {
            state.taxes = null
        },
        resetAddTaxesResponse: (state) => {
            state.addTaxes = null
        },
        resetGetTaxesResponse: (state) => {
            state.getTaxes = null
        },
        resetEditTaxesResponse: (state) => {
            state.editTaxes = null
        },
        resetDeleteTaxesResponse: (state) => {
            state.deleteTaxes = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionTaxes.pending, (state) => {
                state.loading = true
            })
            .addCase(actionTaxes.fulfilled, (state, action) => {
                state.loading = false
                state.taxes = action.payload
            })
            .addCase(actionTaxes.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddTaxes.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddTaxes.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addTaxes = action.payload
            })
            .addCase(actionAddTaxes.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetTaxes.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetTaxes.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getTaxes = action.payload
            })
            .addCase(actionGetTaxes.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditTaxes.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditTaxes.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editTaxes = action.payload
            })
            .addCase(actionEditTaxes.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteTaxes.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteTaxes.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteTaxes = action.payload
            })
            .addCase(actionDeleteTaxes.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetTaxesResponse, resetAddTaxesResponse, resetGetTaxesResponse, resetEditTaxesResponse, resetDeleteTaxesResponse } = appTaxesSlice.actions

export default appTaxesSlice.reducer